export default __webpack_public_path__ + "buysearchsell/images/favicon-32x32.png";